/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { CustomerNotificationTypeEnumType } from "./CustomerNotificationTypeEnum"
import { NotificationStatusEnumType } from "./NotificationStatusEnum"
import { RootStoreType } from "./index"


/**
 * CustomerNotificationLogDtoBase
 * auto generated base class for the model CustomerNotificationLogDtoModel.
 */
export const CustomerNotificationLogDtoModelBase = ModelBase
  .named('CustomerNotificationLogDto')
  .props({
    __typename: types.optional(types.literal("CustomerNotificationLogDto"), "CustomerNotificationLogDto"),
    actionUuid: types.union(types.undefined, types.string),
    orderUuid: types.union(types.undefined, types.string),
    projectId: types.union(types.undefined, types.integer),
    notificationType: types.union(types.undefined, CustomerNotificationTypeEnumType),
    notificationTime: types.union(types.undefined, types.null, types.string),
    status: types.union(types.undefined, NotificationStatusEnumType),
    email: types.union(types.undefined, types.null, types.string),
    emailPartialId: types.union(types.undefined, types.null, types.string),
    emailId: types.union(types.undefined, types.null, types.string),
    phoneNumber: types.union(types.undefined, types.null, types.string),
    smsId: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CustomerNotificationLogDtoModelSelector extends QueryBuilder {
  get actionUuid() { return this.__attr(`actionUuid`) }
  get orderUuid() { return this.__attr(`orderUuid`) }
  get projectId() { return this.__attr(`projectId`) }
  get notificationType() { return this.__attr(`notificationType`) }
  get notificationTime() { return this.__attr(`notificationTime`) }
  get status() { return this.__attr(`status`) }
  get email() { return this.__attr(`email`) }
  get emailPartialId() { return this.__attr(`emailPartialId`) }
  get emailId() { return this.__attr(`emailId`) }
  get phoneNumber() { return this.__attr(`phoneNumber`) }
  get smsId() { return this.__attr(`smsId`) }
}
export function selectFromCustomerNotificationLogDto() {
  return new CustomerNotificationLogDtoModelSelector()
}

export const customerNotificationLogDtoModelPrimitives = selectFromCustomerNotificationLogDto().actionUuid.orderUuid.projectId.notificationType.notificationTime.status.email.emailPartialId.emailId.phoneNumber.smsId
